<script setup>
import {onMounted} from "vue";
import {Capacitor} from "@capacitor/core";
import { StatusBar } from '@capacitor/status-bar'

onMounted(async () => {
  if (Capacitor.getPlatform() === 'ios') {
    try {
      // Disable overlay to place WebView below status bar
      await StatusBar.setOverlaysWebView({ overlay: false })

    } catch (error) {
      console.error('Error configuring status bar:', error)
    }
  }
})

</script>

<template>
  <div id="app">
    <router-view></router-view>
  </div>

</template>

<style>
#app {
  height: 100vh;
  font-size: 13px;
  font-family: Montserrat, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
